import { InternalMetrics } from '@arpeggi/shared'
import { minutesToMilliseconds } from 'date-fns'
import { useQuery } from 'react-query'
import { useInternalMetricsAPI } from '../api/v2/InternalMetricsAPI'

export const useInternalMetrics = () => {
  const { getInternalMetrics } = useInternalMetricsAPI()

  return useQuery<InternalMetrics>(['internal-metrics'], () => getInternalMetrics(), {
    refetchInterval: minutesToMilliseconds(1)
  })
}
